<template>
    <div class="app-content">
        <div v-show="currentShowPage == 1">
            <div class="app-title mb10">
                <!-- 应用标题 -->
                <div class="app-titles">
                    <i :class="currentSelectMenuData.css" class="app-title-icon"></i>
                    <span class="app-title-main">{{currentSelectMenuData.name}}</span>
                </div>
                <!-- 列表按钮 -->
                <div class="app-buttons">
                    <el-button icon="icon-add" class="btn-green" size="mini" @click="addBtn">
                        <font>新建</font>
                    </el-button>
                    <el-button icon="icon-trash-2" class="btn-red" size="mini" @click="delBtn">
                        <font>删除</font>
                    </el-button>
                </div>
            </div>
            <!-- 列表高级搜索 -->
            <div>
                <el-row :gutter="20">
                    <el-form inline-message :model="searchList" label-width="100px">
                        <el-col :span="6">
                            <el-form-item label="菜单名称">
                                <el-input size="mini" v-model="searchList.name" @keyup.enter.native="searchBtn"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" style="line-height:40px">
                            <el-button icon="icon-search" class="btn btn-blue" size="mini" type="primary" @click="searchBtn">搜索</el-button>
                            <el-button icon="icon-refresh" class="btn-blue" size="mini" @click="resetBtn">重置</el-button>
                        </el-col>
                    </el-form>
                </el-row>
            </div>
            <!-- 表格 -->
            <el-table lazy class="app-table" ref="vtable" :data="tableData" row-key="id" stripe highlight-current-row :height="fullHeight" @selection-change="selectTableData" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" :load="load">
                <el-table-column type="selection" width="55" :reserve-selection="true">
                </el-table-column>
                <el-table-column prop="name" label="菜单名称" :show-overflow-tooltip="true">
                    <template slot-scope="props">
                        <span class="blue" title="点击查看详情" @click="viewBtn(props.row)">{{props.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="url" label="菜单地址" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" width="100" prop="isstandard" label="标准应用？" :show-overflow-tooltip="true" :formatter="formatterData">
                </el-table-column>
                <el-table-column align="center" width="100" prop="hidden" label="是否隐藏？" :show-overflow-tooltip="true" :formatter="formatterData">
                </el-table-column>
                <el-table-column align="center" width="100" prop="canauthorization" label="允许授权？" :show-overflow-tooltip="true" :formatter="formatterData">
                </el-table-column>
            </el-table>
        </div>
        <menumanagementdetail v-show="currentShowPage == 2" ref="menumanagementdetail" @requestData="getData('reset')"></menumanagementdetail>
    </div>
</template>

<script>

import menumanagementdetail from "./menu_managementdetail"
export default {
    name:"menu_management",
    components:{menumanagementdetail},
    data(){
        return{
            tableData:[],
            fullHeight: document.documentElement.clientHeight - 185,//获取浏览器高度
            loading:false,
            selectTableList:[],
            basic_url: Config.dev_url,//请求地址
            drawer:false,
            searchList:{}
        }
    },
    directives:{
        drag:{
            bind:function(el){
                let odiv = el;
                odiv.onmousedown = (e) =>{
                    let disX = e.clientX - odiv.offsetLeft;
                    let disY = e.clientY - odiv.offsetTop;
                    document.onmousemove = (e) =>{
                        let left = e.clientX - disX;
                        let top = e.clientY - disY;
                        odiv.style.left = left + "px";
                        odiv.style.top = top + "px";
                    };
                    document.onmouseup = (e) =>{
                        document.onmousemove = null
                        document.onmouseup = null
                    }
                }
            }
        }
    },
    computed:{
        //当前左侧菜单选中的信息
        currentSelectMenuData(){
            return this.$store.state.currentSelectMenuData
        },
        //列表显示的按钮
        listButtons(){
            return this.$store.state.buttons
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
        currentShowPage(){
            return this.$store.state.currentShowPage
        },
    },
    methods:{
        //删除高级搜索显示的某个tag
        closeSearchTagBtn(val){
            this.searchList.name = ""
            this.getData()
        },
        //主表列表高级搜索
        searchBtn() {
            this.drawer = false
            this.searchData()
        },
        //主表列表重置按钮
        resetBtn() {
            this.searchList = {}
            this.drawer = false
            this.getData()
        },
        formatterData(row,column,cellindex,index){
            return row[column.property] == 1 ? '是' : '否'
        },
        btnClick(item){
            console.log(item)
            this[item.eventmethod]()
        },
        //查看数据详情
        viewBtn(item){
            this.$store.commit('setcurrentShowPage',2)
            this.$refs.menumanagementdetail.view(item)
        },
        //新建按钮
        addBtn(){
            this.$store.commit('setcurrentShowPage',2)
            this.$refs.menumanagementdetail.addBtn()
        },
        delBtn(){
            if(this.selectTableList.length == 0){
                this.$message.warning("请选择要删除的数据")
                return
            }else if(this.selectTableList.length > 1){
                this.$message.warning("不可以同时删除多个数据")
                return
            }
            this.$confirm("确定删除此数据吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消"
            }).then(({ value }) => {
                let url = Config.dev_url + '/api-user/menus/' + this.selectTableList[0].code;
                this.$axios.delete(url, {}).then((res) => { //.delete 传数据方法
                    if(res.data.code == 0){
                        this.$message.success(res.data.msg)
                        this.getData('reset');
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                }).catch((err) => { });
            })
        },
        //选中表格某条数据时触发
        selectTableData(val) {
            this.selectTableList = val
        },
        load(tree, treeNode, resolve) {
            console.log(tree,treeNode)
            this.loading = true
            var url = Config.dev_url + "/api-user/menus/findTreeByMenuCode"
            var data = {
                rolecode:this.currentuser.rolecode,
                menucode:tree.code,
            }
            this.$axios.post(url,data).then((res)=>{
                this.loading = false
                for (let i = 0; i < res.data.length; i++) {
                    res.data[i].hasChildren = true
                }
                resolve(res.data)
            }).catch((err) => {
                });
        },
        //高级搜索
        searchData(){
            var data = {
                name: this.searchList.name
            }
            var url = Config.dev_url + '/api-user/menus/findTreeMap';//把findTreeAlls修改了成了findTreeMap接口，之前那个高级查询不能使用。heliping20190429
            this.$axios.get(url, {
                params: data
            }).then((res) => {
                this.loading = false;
                let result = res.data
                this.tableData = result;
            }).catch((wrong) => {

            })
        },
        //获取数据
        getData(str){
            if(str == 'reset'){
                this.tableData = []
            }
            var url = Config.dev_url + "/api-user/menus/firstTree"
            this.$axios.post(url,{rolecode:this.currentuser.rolecode}).then((res)=>{
                this.$refs.vtable.clearSelection()
                this.loading = false
                for (let i = 0; i < res.data.length; i++) {
                    res.data[i].hasChildren = true
                }
                this.tableData = res.data
            }).catch((err) => {
                });

        },
    },
    mounted(){
        this.$store.commit('setcurrentShowPage',1)
        this.getData()
    }
}
</script>

<style>

</style>
